export const configurationProfiles = {
  developmentConfig: {
    // apiRoot: "http://localhost:1935",
    // authAuthorityUrl: 'http://localhost:1935/api/'
    // authAppBaseUrl: 'http://localhost:8085'
  },
};
